export const DELETE_PROJECT_REQUEST = " DELETE_PROJECT_REQUEST";
export const DELETE_PROJECT_SUCCESS = " DELETE_PROJECT_SUCCESS";
export const DELETE_PROJECT_FAILURE = " DELETE_PROJECT_FAILURE";
